import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, MenuItem, Select, FormControl, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
// import RenderAutoCompleteRedux from '../Complements/RenderAutocompleteRedux';

const useStyles = makeStyles(theme => ({
  textField: {
    width: 200,
  },
  margin: {
    margin: theme.spacing(1),
  },
}));
const validate = values => {
    const error  = {}
    if (!values.code) {
        error.code = "La empresa eléctrica es obligatoria"
    }
    return error
}

const ElectricTaxeForm = props => {
    const classes = useStyles();
    const { handleSubmit, companies, setFormTaxe, pristine, onCancelAction  } = props
    // const { code } = formTaxe
    const handleCompanyChange = (e) => {
        setFormTaxe(prevState => ({
                ...prevState,
                company: e
            }))
    }
    return (
        <form className={classes.form} onSubmit={ handleSubmit }>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <FormControl variant="outlined" style = {{width: '100%'}}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione Empresa electrica</InputLabel>
                        <Select
                            label="Seleccione Empresa electrica"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue = { companies[0]}
                            onChange={(e) => handleCompanyChange(e.target.value) }
                        >
                            {
                                companies.map(option => {
                                    return <MenuItem key={option.Secuencial} value={option}>{`${option.Descripcion}`}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Field
                        name="code"
                        id="code"
                        component={ RenderTextFieldRedux }
                        label="Código"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6} md={6}>
                    <Button variant="contained" type="submit"
                        fullWidth
                        color="primary"
                        disabled={pristine }
                        >
                        Consultar
                    </Button>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Button variant="contained" className={classes.button} onClick = { () => onCancelAction() }>
                        Cancelar
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

ElectricTaxeForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    companies: PropTypes.array.isRequired,
    onCancelAction: PropTypes.func.isRequired,
};

const ElectricTaxeReduxForm = reduxForm(
    {
      form: 'ElectricTaxeForm',
      validate
    }
)(ElectricTaxeForm)
export default ElectricTaxeReduxForm

// export default ElectricTaxeForm;